import { useContext } from "react";
import { motion } from "framer-motion";
import { LanguageContext } from "../../../context/LanguageContext";

export default function Features() {
  const { t, isRTL } = useContext(LanguageContext);
  const features = t("features.items", { returnObjects: true }) || [];

  return (
    <section
      dir={isRTL ? "rtl" : "ltr"}
      className="bg-white py-24"
    >
      <div className="mx-auto max-w-7xl px-6">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="text-4xl font-extrabold text-black">
            {t("features.title")}
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-600">
            {t("features.subtitle")}
          </p>
        </motion.div>

        {/* Grid */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            visible: {
              transition: { staggerChildren: 0.08 },
            },
          }}
          className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3"
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              variants={{
                hidden: { opacity: 0, y: 20 },
                visible: { opacity: 1, y: 0 },
              }}
              whileHover={{ y: -6, scale: 1.02 }}
              transition={{ duration: 0.3 }}
              className="rounded-2xl border border-gray-200 bg-rose-50 p-6 shadow-sm"
            >
              <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-indigo-100">
                <span className="h-4 w-4 rounded-full bg-indigo-600"></span>
              </div>

              <h3 className="text-lg font-semibold text-black">
                {feature.title}
              </h3>

              <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
}
